<template>
  <section class="site-info">
    <div class="container">
      <p class="info">
        <span>بنك الدم</span>
        هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد تم توليد هذا
        النص من مولد النص العربى ، حيث يمكنك أن تولد مثل هذا النص أو العديد من
        النصوص الأخرى . <br />إضافة إلى زيادة عدد الحروف التى يولدها التطبيق<br />
        يطلع على صورة حقيقية لتصميم الموقع
      </p>
      <p></p>
    </div>
  </section>
</template>

<script>
export default {};
</script>
